import { ClientNames } from '../../enums';
export var DEMO_CLIENTS = [
    ClientNames.Demo.toString(),
    ClientNames.DemoCorp.toString(),
    ClientNames.DemoClient.toString(),
    ClientNames.GwDemoClient.toString(),
    ClientNames.GorillaWorks.toString()
];
